import { IAccountSetting } from '../interfaces/IAccountSetting';
import { IUserPhoneNumberResponse } from '../interfaces/IUser';

export default class AccountSetting {
  isSmsOnly: boolean;
  isVerified: boolean;
  isVisible: boolean;
  phoneAlpha2Code: string | null;
  phoneCountryCode: string | null;
  phoneNumber: string | null;
  userCountry: string | null;
  userCountryCode: string | null;

  constructor() {
    this.isSmsOnly = false;
    this.isVerified = false;
    this.isVisible = false;
    this.phoneAlpha2Code = null;
    this.phoneCountryCode = null;
    this.phoneNumber = null;
    this.userCountry = null;
    this.userCountryCode = null;
  }

  static mappingObjectNumberPhone(user: IUserPhoneNumberResponse): IAccountSetting {
    const obj = new AccountSetting();
    obj.isSmsOnly = user.IsSmsOnly ?? false;
    obj.isVerified = user.IsVerified ?? false;
    obj.isVisible = user.IsVisible ?? false;
    obj.phoneAlpha2Code = user.PhoneAlpha2Code ?? null;
    obj.phoneCountryCode = user.PhoneCountryCode ?? null;
    obj.phoneNumber = user.PhoneNumber ?? null;
    obj.userCountry = user.UserCountry ?? null;
    obj.userCountryCode = user.UserCountryCode ?? null;
    return obj;
  }
}
